module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-20-min.a6209242.jpg";